/**
 * PaxRent facts referenced by homepage copy.
 *
 * The launch date lives here so no page hardcodes it twice.
 *
 * Do NOT derive an elapsed duration from PAXRENT_LAUNCH_ISO. Elapsed-duration
 * phrasing ("five months of operation") goes stale silently, which is exactly
 * what #7921 forbids, and this page is statically generated, so a computed
 * duration would also need `export const revalidate` on every consuming page to
 * refresh at all. Anchor copy to the date instead. Every string on the homepage
 * today is either date-anchored or duration-free, so nothing computes.
 */

/** Production launch, 15 March 2026. */
export const PAXRENT_LAUNCH_ISO = '2026-03-15';

/** Display form of PAXRENT_LAUNCH_ISO, for copy that names the month. */
export const PAXRENT_LAUNCH_LABEL = 'March 2026';

export const PAXRENT_URL = 'https://www.paxrent.com';
